// Single source of truth for the current Hyderabad Toofans squad and support staff.
// Player order is the order shown on the Squad page (grouped by position).

import ArshdeepSinghCard from '../assets/players/arshdeep-singh/card.webp';
import ArshdeepSinghInfo from '../assets/players/arshdeep-singh/info.webp';
import TalwinderSinghCard from '../assets/players/talwinder-singh/card.webp';
import TalwinderSinghInfo from '../assets/players/talwinder-singh/info.webp';
import JacobAndersonCard from '../assets/players/jacob-anderson/card.webp';
import JacobAndersonInfo from '../assets/players/jacob-anderson/info.webp';
import TimothyDanielCard from '../assets/players/timothy-daniel/card.webp';
import TimothyDanielInfo from '../assets/players/timothy-daniel/info.webp';
import ShilanandLakraCard from '../assets/players/shilanand-lakra/card.webp';
import ShilanandLakraInfo from '../assets/players/shilanand-lakra/info.webp';
import IrengbamRohitCard from '../assets/players/irengbam-rohit/card.webp';
import IrengbamRohitInfo from '../assets/players/irengbam-rohit/info.webp';
import NilakantaSharmaCard from '../assets/players/nilakanta-sharma/card.webp';
import NilakantaSharmaInfo from '../assets/players/nilakanta-sharma/info.webp';
import AakibRahimCard from '../assets/players/aakib-rahim/card.webp';
import AakibRahimInfo from '../assets/players/aakib-rahim/info.webp';
import RajinderSinghCard from '../assets/players/rajinder-singh/card.webp';
import RajinderSinghInfo from '../assets/players/rajinder-singh/info.webp';
import ZachWallaceCard from '../assets/players/zach-wallace/card.webp';
import ZachWallaceInfo from '../assets/players/zach-wallace/info.webp';
import SumitWalmikiCard from '../assets/players/sumit-walmiki/card.webp';
import SumitWalmikiInfo from '../assets/players/sumit-walmiki/info.webp';
import MichelStruthoffCard from '../assets/players/michel-struthoff/card.webp';
import MichelStruthoffInfo from '../assets/players/michel-struthoff/info.webp';
import AmandeepLakraCard from '../assets/players/amandeep-lakra/card.webp';
import AmandeepLakraInfo from '../assets/players/amandeep-lakra/info.webp';
import DevWalmikiCard from '../assets/players/dev-walmiki/card.webp';
import DevWalmikiInfo from '../assets/players/dev-walmiki/info.webp';
import ArthurDeSlooverCard from '../assets/players/arthur-de-sloover/card.webp';
import ArthurDeSlooverInfo from '../assets/players/arthur-de-sloover/info.webp';
import NicholasWoodsCard from '../assets/players/nicholas-woods/card.webp';
import NicholasWoodsInfo from '../assets/players/nicholas-woods/info.webp';
import MukulSharmaCard from '../assets/players/mukul-sharma/card.webp';
import MukulSharmaInfo from '../assets/players/mukul-sharma/info.webp';
import SundaramRajawatCard from '../assets/players/sundaram-rajawat/card.webp';
import SundaramRajawatInfo from '../assets/players/sundaram-rajawat/info.webp';
import BikramjitSinghCard from '../assets/players/bikramjit-singh/card.webp';
import BikramjitSinghInfo from '../assets/players/bikramjit-singh/info.webp';
import JeanPaulDannebergCard from '../assets/players/jean-paul-danneberg/card.webp';
import JeanPaulDannebergInfo from '../assets/players/jean-paul-danneberg/info.webp';
import PashaGademanCard from '../assets/staff/pasha-gademan/card.webp';
import PashaGademanInfo from '../assets/staff/pasha-gademan/info.webp';
import RobinArkellCard from '../assets/staff/robin-arkell/card.webp';
import RobinArkellInfo from '../assets/staff/robin-arkell/info.webp';
import EimilyCaledronCard from '../assets/staff/eimily-caledron/card.webp';
import EimilyCaledronInfo from '../assets/staff/eimily-caledron/info.webp';
import DarrenLoboCard from '../assets/staff/darren-lobo/card.webp';
import DarrenLoboInfo from '../assets/staff/darren-lobo/info.webp';
import SiddharthYadavCard from '../assets/staff/siddharth-yadav/card.webp';
import SiddharthYadavInfo from '../assets/staff/siddharth-yadav/info.webp';

export const POSITION_GROUPS = ['Forward', 'Midfielder', 'Defender', 'Goalkeeper'];

export const players = [
  {
    id: 'arshdeep-singh',
    name: 'Arshdeep Singh',
    position: 'Forward',
    group: 'Forward',
    bio: 'One of the most exciting young players in the country today. Just won the Asia Cup in Muscat, and is sure to get into the senior team in the next few years. Is from Amritsar and one of the 4 young players (U21) in the team today. Is a product of the Roundglass Academy which has made tremendous efforts in grassroots hockey in Punjab.',
    images: { card: ArshdeepSinghCard, info: ArshdeepSinghInfo },
  },
  {
    id: 'talwinder-singh',
    name: 'Talwinder Singh',
    position: 'Forward',
    group: 'Forward',
    bio: 'From Jalandhar. Employed with Indian Oil Corp and plays for them. One of the senior players in the group and a very dangerous striker who knows where the goal is. One of the many PSPB players in the group.',
    images: { card: TalwinderSinghCard, info: TalwinderSinghInfo },
  },
  {
    id: 'jacob-anderson',
    name: 'Jacob Anderson',
    position: 'Forward',
    group: 'Forward',
    bio: 'Jacob is one of the two Australians in the team. Also plays striker just like Tim Brand. Recently married. Has a BSc in Athletic Performance. When not playing hockey, Jacob is a qualified Strength and Conditioning Coach and a Personal Trainer. Recently married and came into the team as a replacement player for Terrence Pieters.',
    images: { card: JacobAndersonCard, info: JacobAndersonInfo },
  },
  {
    id: 'timothy-daniel',
    name: 'Timothy Daniel',
    position: 'Forward',
    group: 'Forward',
    bio: 'Tim is from Sydney, Australia. Trains and lives in either Perth where the national team is based or Hamburg in Germany where he plays Club hockey. Has dual citizenship. Carries a Dutch and an Australian passport. One of the most explosive forwards in world hockey right now and one of the most important players in the team.',
    images: { card: TimothyDanielCard, info: TimothyDanielInfo },
  },
  {
    id: 'shilanand-lakra',
    name: 'Shilanand Lakra',
    position: 'Forward',
    group: 'Forward',
    bio: 'One of the two players in the team from Rourkela. The other being Amandeep Lakra. Is having an outstanding season where he spearheaded the attack for Odisha as they went on to win the national championship for the first time. Scored a hattrick in the final. Back in the Indian team as well after he suffered a horrific injury. A product of the SAIL Academy in Rourkela. One of the two big academies in the city.',
    images: { card: ShilanandLakraCard, info: ShilanandLakraInfo },
  },
  {
    id: 'irengbam-rohit',
    name: 'Irengbam Rohit',
    position: 'Forward',
    group: 'Forward',
    bio: 'One of the two players from Manipur in the team. Youngest player in the team. Currently part of the high Performance Programme in Bhubaneswar. Athletically, one of the best players in the team despite his age.',
    images: { card: IrengbamRohitCard, info: IrengbamRohitInfo },
  },
  {
    id: 'nilakanta-sharma',
    name: 'Nilakanta Sharma',
    position: 'Midfielder',
    group: 'Midfielder',
    bio: 'The only Indian player in the team who has kids. Currently employed in Imphal as a Class 1 Officer with the State Govt there. He and Sumit go back a long way and 10 years ago won the Junior World Cup for India together before winning India’s first medal at the Olympics in 42yrs. Very reserved. But an amazing personality on and off the pitch once you get to know him. Highly respected by his peers and definitely one of the leaders in the team. Product of Madhya Pradesh Hockey Academy.',
    images: { card: NilakantaSharmaCard, info: NilakantaSharmaInfo },
  },
  {
    id: 'aakib-rahim',
    name: 'Aakib Rahim',
    position: 'Midfielder',
    group: 'Midfielder',
    bio: 'Aakib comes from a hockey playing family from Nagpur. His elder brother Niyaz plays for South Central Railway. Aakib plays for the Indian Navy and has been a Navyman for a few years now. Powerful midfielder who has represented Maharashtra and Navy for years now.',
    images: { card: AakibRahimCard, info: AakibRahimInfo },
  },
  {
    id: 'rajinder-singh',
    name: 'Rajinder Singh',
    position: 'Midfielder',
    group: 'Midfielder',
    bio: 'From Sirsa, Haryana. Product of the Namdhari Hockey Academy in Haryana. Widely considered the next big midfielder from India. Plays, moves and idolises former India Captain and his mentor, Sardar Singh. Has family in Australia.',
    images: { card: RajinderSinghCard, info: RajinderSinghInfo },
  },
  {
    id: 'zach-wallace',
    name: 'Zach Wallace',
    position: 'Midfielder',
    group: 'Midfielder',
    bio: 'One of the best midfielders in the world right now and an FIH World Player of the year nominee. Plays and lives with his partner in the Netherlands. Plays for one of the best clubs there, Bloemendaal. Comes into the HIL with a busy schedule behind him. Was in Argentina until a few days ago representing England in the FIH Pro League. Was the last foreigner to join the group.',
    images: { card: ZachWallaceCard, info: ZachWallaceInfo },
  },
  {
    id: 'sumit-walmiki',
    name: 'Sumit Walmiki',
    position: 'Midfielder',
    group: 'Midfielder',
    bio: 'Undoubtedly the leader amongst the Indians and the most decorated Indian player in the team with two Olympic medals. The son of a driver, Sumit is the best defender in his position in the country today. Not married but soon to be. His partner is International hockey player Sonika. Employed with ONGC and plays for them in domestic hockey. From Sonipat in Haryana. Won his first Olympic medal after tragically losing his mother weeks before the Games. Mentally one of the strongest individuals you are likely to meet.',
    images: { card: SumitWalmikiCard, info: SumitWalmikiInfo },
  },
  {
    id: 'michel-struthoff',
    name: 'Michel Struthoff',
    position: 'Midfielder',
    group: 'Midfielder',
    bio: 'A dynamic and versatile midfielder, Michel Struthoff brings pace, intensity, and tactical intelligence to the Hyderabad Toofans lineup. Known for his ability to control the tempo of the game and contribute at both ends of the pitch, the German international adds valuable European experience to the squad.',
    images: { card: MichelStruthoffCard, info: MichelStruthoffInfo },
  },
  {
    id: 'amandeep-lakra',
    name: 'Amandeep Lakra',
    position: 'Defender',
    group: 'Defender',
    bio: 'Son of Bijoy Kumar Lakra, one of the biggest coaches in Odisha. The father and son duo won the National Championship a few weeks ago. Amandeep is from the other big academy in Rourkela, the Panposh Hockey Academy. Has been a big year for Aman, won the National Championship as well as made his debut for the national team.',
    images: { card: AmandeepLakraCard, info: AmandeepLakraInfo },
  },
  {
    id: 'dev-walmiki',
    name: 'Dev Walmiki',
    position: 'Defender',
    group: 'Defender',
    bio: 'Brother of Yuvraj Walmiki who also played for India. Both the brothers came through extremely tough circumstances in Mumbai to become Olympians. One of the senior players in the group and is part of BPCL and is captain of PSPB which is one of the top teams in the country. Highest following on social media amongst all the players in the team.',
    images: { card: DevWalmikiCard, info: DevWalmikiInfo },
  },
  {
    id: 'arthur-de-sloover',
    name: 'Arthur De Sloover',
    position: 'Defender',
    group: 'Defender',
    bio: 'Lives and trains in Antwerp where the Belgian Hockey Performance Centre is. Is a World and Olympic Champion with Belgium and only one of the two we have in the team along with Gonzalo. Currently playing Club hockey in Holland for Oranje Rood. Not married and loves Rolex watches. Will definitely be part of the leadership group.',
    images: { card: ArthurDeSlooverCard, info: ArthurDeSlooverInfo },
  },
  {
    id: 'nicholas-woods',
    name: 'Nicholas Woods',
    position: 'Defender',
    group: 'Defender',
    bio: 'One of the most experienced players in the group. Currently playing in Germany for Hamburg with 2 other players in our team, Dom Dixon and Tim Brand. Is from New Zealand one of the 4 players in the team who has captained his national team. Is going to play a key role for us in midfield.',
    images: { card: NicholasWoodsCard, info: NicholasWoodsInfo },
  },
  {
    id: 'mukul-sharma',
    name: 'Mukul Sharma',
    position: 'Defender',
    group: 'Defender',
    bio: 'Mukul is from Delhi and plays for South Central Railway. Our training camp was actually his home base. Our coaches are extremely impressed with his athletic ability. Not married and lives in Hyderabad.',
    images: { card: MukulSharmaCard, info: MukulSharmaInfo },
  },
  {
    id: 'sundaram-rajawat',
    name: 'Sundaram Rajawat',
    position: 'Defender',
    group: 'Defender',
    bio: 'Much like Nilakanta, product of the MP Academy in Madhya Pradesh. Hometown is Itarsi. One of the 4 U-21 boys in the team. Lives and trains in Bhopal.',
    images: { card: SundaramRajawatCard, info: SundaramRajawatInfo },
  },
  {
    id: 'bikramjit-singh',
    name: 'Bikramjit Singh',
    position: 'Goalkeeper',
    group: 'Goalkeeper',
    bio: 'The best u-21 goalkeeper in India. From Chandigarh and developing extremely well. Along with Arshdeep, just won the Jr Asia Cup in Oman. Highly rated by Sreejesh.',
    images: { card: BikramjitSinghCard, info: BikramjitSinghInfo },
  },
  {
    id: 'jean-paul-danneberg',
    name: 'Jean-Paul Danneberg',
    position: 'Goalkeeper',
    group: 'Goalkeeper',
    bio: "An elite presence between the posts, Jean Paul Dannberg is the FIH Goalkeeper of the Year, recognised globally for his exceptional reflexes, composure, and match-winning saves. With vast experience at the highest level of international hockey, the German custodian brings leadership, calmness, and reliability to the Hyderabad Toofans' defence.",
    images: { card: JeanPaulDannebergCard, info: JeanPaulDannebergInfo },
  },
];

export const staff = [
  {
    id: 'pasha-gademan',
    name: 'Pasha Gademan',
    role: 'Chief Coach',
    nationality: 'Netherlands',
    images: { card: PashaGademanCard, info: PashaGademanInfo },
  },
  {
    id: 'robin-arkell',
    name: 'Robin Arkell',
    role: 'Scientific Advisor',
    nationality: 'Germany',
    images: { card: RobinArkellCard, info: RobinArkellInfo },
  },
  {
    id: 'eimily-caledron',
    name: 'Eimily Caledron',
    role: 'Asst. Coach',
    nationality: 'Belgium',
    images: { card: EimilyCaledronCard, info: EimilyCaledronInfo },
  },
  {
    id: 'darren-lobo',
    name: 'Darren Lobo',
    role: 'Asst. Coach',
    nationality: '',
    images: { card: DarrenLoboCard, info: DarrenLoboInfo },
  },
  {
    id: 'siddharth-yadav',
    name: 'Siddharth Yadav',
    role: 'General Manager',
    nationality: 'India',
    images: { card: SiddharthYadavCard, info: SiddharthYadavInfo },
  },
];

export const playersByGroup = POSITION_GROUPS.map((group) => ({
  group,
  players: players.filter((player) => player.group === group),
}));
